export * from './BaseMenu';
export * from './menu.model';
export type { MenuProps } from './Menu';
export type { MenuGroupProps } from './MenuGroup';
export type { MenuActionProps } from './MenuAction';
export type { MenuItemProps } from './MenuItem';
export type { MenuItemSubmenuProps } from './MenuItemSubmenu';

import { Menu as MenuRoot } from './Menu';
import { MenuItem } from './MenuItem';
import { MenuGroup } from './MenuGroup';
import { MenuDivider } from './MenuDivider';
import { MenuAction } from './MenuAction';
import { MenuItemSubmenu } from './MenuItemSubmenu';
import { MenuCheckboxItem } from './MenuCheckboxItem';

export const Menu = Object.assign(MenuRoot, {
  Item: MenuItem,
  Group: MenuGroup,
  Divider: MenuDivider,
  Action: MenuAction,
  Submenu: MenuItemSubmenu,
  CheckboxItem: MenuCheckboxItem,
});

export { useMenuContext } from './MenuContext';
